// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"footer-module--footerWrapper--1MgLq","footerWrapperInner":"footer-module--footerWrapperInner--XvNJ_","footerWrapperText":"footer-module--footerWrapperText--bed57"};